module.exports = __webpack_public_path__ + "img/end-header-background-en.de330a3e.png";